<script setup lang="ts">
const props = defineProps<{
	modelValue?: string[] | null;
	name: string;
	options: { value: string; text: string }[];
	id?: string;
	placeholder?: string | null;
	'aria-describedby'?: string;
	'aria-invalid'?: boolean;
	class?: string;
}>();

const emits = defineEmits(['update:modelValue']);

// Assicurati che modelValue sia sempre un array
const modelValueArray = computed(() => {
	return Array.isArray(props.modelValue) ? props.modelValue : [];
});

const isChecked = (value: string) => modelValueArray.value.includes(value);

const toggleValue = (value: string, checked: boolean) => {
	let updatedValues = [...modelValueArray.value];

	if (checked) {
		updatedValues.push(value);
	} else {
		updatedValues = updatedValues.filter((v) => v !== value);
	}

	emits('update:modelValue', updatedValues);
};
</script>

<template>
	<div class="space-y-2">
		<div v-for="option in props.options" :key="option.value" class="flex items-center gap-x-2">
			<Checkbox
				:id="`${props.name}-${option.value}`"
				:checked="isChecked(option.value)"
				@update:checked="(checked) => toggleValue(option.value, checked)"
			/>
			<Label :for="`${props.name}-${option.value}`" class="text-sm uppercase text-black">
				{{ option.text }}
			</Label>
		</div>
	</div>
</template>
